export interface JebbitData {
  products: JebbitProduct[];
  selected: JebbitProduct[];
}

export class JebbitProduct {
  fields!: {
    jebbitId: string;
    description: string;
    name: string;
    shortTitle: string;
    prePurchaseProductDescription: string;
    prePurchaseCustomerReview: string;
    prePurchaseBestMatchProductTip: string;
    displayNamePrePurchaseProductList: string;
    productVariants: {
      fields: any;
      metadata: any;
      sys: any;
    }[];
    prePurchaseComparePoints: {
      metadata: any;
      sys: any;
      fields: {
        name: string;
        image?: string;
        text: string;
        accessories?: string;
        modes?: any[];
        _tooltipHTML: string /** field created and filled by us, does not come from contetful. */;
      };
    }[];
    mainAsset: {
      fields: {
        asset: {
          fields: {
            file: {
              url: string;
            };
          };
        };
      };
    };
  };

  metadata: any;

  sys!: {
    contentType: {
      sys: {
        id: string;
        type: string;
      };
    };
  };

  constructor() {}
}
